{
  "version": 1,
  "asset_id": "0793a1af-5efc-4d9f-a1c1-bc3dc6704fce",
  "project_id": "7ac59465-c0f2-4b6e-9949-d18c7a8fae04",
  "url": "/__l5e/assets-v1/0793a1af-5efc-4d9f-a1c1-bc3dc6704fce/case-bowlscoreboard-cover.png",
  "r2_key": "a/v1/7ac59465-c0f2-4b6e-9949-d18c7a8fae04/0793a1af-5efc-4d9f-a1c1-bc3dc6704fce/case-bowlscoreboard-cover.png",
  "original_filename": "case-bowlscoreboard-cover.png",
  "size": 2528261,
  "content_type": "image/png",
  "created_at": "2026-08-20T13:13:17Z"
}
